import { Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { Trans } from '@lingui/react/macro'
import { useFetchUser } from '../authorization/api/useFetchUser'

export const ProfileInfoBlock = () => {
  const { data: user } = useFetchUser(true)

  return (
    <div className="max-tablet:pr-0 max-mobile:w-[unset] w-[270px] pr-10">
      <Text type="subtitle-semibold">
        <Trans>Profile</Trans>
      </Text>
      <div className="mt-3 flex flex-col gap-4">
        <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
          <Text className="text-gray-90">
            <Trans>Total points</Trans>
          </Text>
          <Text className="color" type="h2">
            {/* Truncate like the leaderboard's `Math.trunc(Number(score))`; formatNumber alone rounds. */}
            {user ? formatNumber(Math.trunc(Number(user.points || 0)), 0) : '-'}
          </Text>
        </div>
        <div className="flex flex-col pb-4">
          <Text className="text-gray-90">
            <Trans>Email</Trans>
          </Text>
          <Text>{user?.email || '-'}</Text>
        </div>
      </div>
    </div>
  )
}
